'use client';

import { c as _c } from "react/compiler-runtime";
import { HeaderLevel1 } from '@/app/components/headers/header-level-1';
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { ProductHeroBannerSliders } from '@/app/cv/components/sections/products/hero-banner/sliders';
import type { ProductBannerSectionProps } from '@/app/cv/components/sections/products/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const ProductHeroBanner = t0 => {
  const $ = _c(17);
  const {
    title,
    description,
    items: t1,
    buttons: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const items = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const buttons = t4;
  if (items.length === 0) {
    return null;
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = createDataAttributes({
      test: "product-banner-section"
    });
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== buttons) {
    t6 = buttons.map(_temp);
    $[5] = buttons;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== description || $[8] !== t6 || $[9] !== title) {
    t7 = <HeaderLevel1 as="div" title={title} description={description} buttons={t6} />;
    $[7] = description;
    $[8] = t6;
    $[9] = title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== items) {
    t8 = <Container size="desktop-only"><ProductHeroBannerSliders items={items} /></Container>;
    $[11] = items;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t7 || $[15] !== t8) {
    t9 = <Section size="none" className="relative" {...t5}>{t7}{t8}</Section>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
function _temp(button) {
  return {
    ...button,
    className: cn(button.className, "w-full md:w-auto")
  };
}